import { OrderDetailStatusPage } from './pages/order-detail-status/order-detail-status.page';
import { Route } from '@angular/router';
import { loginGuard } from '@us/web/auth/data-access';
import { OrderListPage } from './pages/order-list/order-list.page';
import { OrderDetailPage } from './pages/order-detail/order-detail.page';
import { OrderRatingPage } from './pages/order-rating/order-rating.page';
import { OrderTrackingPage } from './pages/order-tracking/order-tracking.page';
import { RouterUtil } from '@us/web/shared/utils';

export const routes: Route[] = [
    {
        path: `:${RouterUtil.Cog.OrderId}`,
        component: OrderDetailPage
    },
    {
        path: `:${RouterUtil.Cog.OrderId}/${RouterUtil.Cog.Status}`,
        component: OrderDetailStatusPage
    },
    {
        path: `:${RouterUtil.Cog.OrderId}/${RouterUtil.Cog.Tracking}`,
        component: OrderTrackingPage
    },
    {
        path: `:${RouterUtil.Cog.OrderId}/${RouterUtil.Cog.Rating}`,
        canActivate: [loginGuard],
        component: OrderRatingPage
    },
    { path: '', component: OrderListPage },
    { path: '**', redirectTo: '' }
];
